import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Line = ({ children, className }) => (
    <span className={
        classNames(
            'bs-gamblingCompliance__line',
            {
                [className]: className !== null,
            },
        )
    }
    >
        {children}
    </span>
);

Line.defaultProps = {
    className: null,
}

Line.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    className: PropTypes.string,
};

export default Line;



// WEBPACK FOOTER //
// /src/js/common/gamblingCompliance/components/Line.jsx